import React, { useState } from "react"
import Pagination from '@mui/material/Pagination'

import '../../assets/style/tablesG.css'
import { FacturasListaItem } from "./FacturasListaItem"

export const TableList = ({ filters, setFilters, list = [] }) => {

    const [page, setPage] = useState(1)

    const handleChange = (event, value) => {
        console.log(value)

        setPage(value)
        const newFilters = {
            ...filters,
            page: value
        }

        setFilters(newFilters)
    }

    return (

        <div className='p-table'>

            {/* {list?.length > 0 && list?.length > 0 &&
                <div className='p-infografia p-1'>
                    <span>F = factura</span>
                    <span>B = boleta</span>
                    <span>R = recibo</span>
                    <span>C = comprobante</span>
                </div>
            } */}

            <div className="row">
                <div className="col d-flex justify-content-end">
                    <Pagination
                        count={10}
                        page={page}
                        size="small"
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className="table-responsive">
                <table className="table p-table-global">
                    <thead className='p-thead-global'>
                        <tr className="text-center p-tr-titles-global">
                            <th scope="col">Número</th>
                            <th scope="col">F. Emisión</th>
                            <th scope="col">F. Vcto.</th>
                            <th scope="col">Estado</th>
                            <th scope="col" className="text-start">Cliente</th>
                            <th scope="col" className="text-start">Descripción factura</th>
                            <th scope="col" className="text-end">Monto Base</th>
                            <th scope="col" className="text-end">Impuesto</th>
                            <th scope="col" className="text-end">Total</th>
                            <th scope="col" className="text-end">Cobrado</th>
                            <th scope="col" className="text-end">Por Cobrar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list?.length > 0 && list?.map(item => (
                            <FacturasListaItem
                                key={item.id}
                                item={item}
                            />
                        ))
                        }
                    </tbody>
                </table>
            </div>
        </div>

    )
}